import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { Box, IconButton } from "@mui/material";
import React from "react";
import CustomDetailBox from "../../applications/summary_tabs/CustomDetailBox";
import CustomTabButton from "../../unit/CustomTabButton";
import LoanACHLog from "./LoanACHLog";
import LoanPaymentsMadeTable from "./LoanPaymentsMadeTable";
import LoanPaymentSourceLog from "./LoanPaymentSourceLog";

const LoanPaymentTab = ({ ...props }) => {
  const appId = props.appId;
  const [activeTab, setActiveTab] = React.useState(1);
  const paymentsLogPrintId = `loan-payments-log-print-${appId}`;
  const achLogPrintId = `loan-ach-log-print-${appId}`;
  const paymentSourceLogPrintId = `loan-payment-source-log-print-${appId}`;

  const handleChange = (newValue: number) => {
    setActiveTab(newValue);
  };

  const handlePrint = () => {
    const printContainerId =
      activeTab === 1
        ? paymentsLogPrintId
        : activeTab === 2
        ? achLogPrintId
        : paymentSourceLogPrintId;
    const printNode = document.getElementById(printContainerId);

    if (!printNode) {
      return;
    }

    const printWindow = window.open("", "_blank", "width=1200,height=800");

    if (!printWindow) {
      return;
    }

    const styles = Array.from(
      document.querySelectorAll('link[rel="stylesheet"], style')
    )
      .map((node) => node.outerHTML)
      .join("");

    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>${
            activeTab === 1
              ? "Loan Payments Log"
              : activeTab === 2
              ? "Loan ACH Log"
              : "Loan Payment Source Log"
          }</title>
          ${styles}
          <style>
            @page {
              size: landscape;
              margin: 10mm;
            }

            html,
            body {
              width: 100%;
              height: auto;
              padding: 8px;
              font-size: 10px;
              line-height: 1.2;
              color: #111;
              overflow: visible !important;
            }

            table {
              width: 100% !important;
              table-layout: fixed;
              border-collapse: collapse;
              page-break-inside: auto;
            }

            thead {
              display: table-header-group;
            }

            tfoot {
              display: table-footer-group;
            }

            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }

            th,
            td {
              font-size: 9px !important;
              padding: 4px 6px !important;
              white-space: normal !important;
              word-break: break-word;
            }

            .hm-table-header {
              font-size: 9px !important;
              line-height: 1.15;
            }

            .amountText,
            .dateText,
            .numericText {
              font-size: 9px !important;
            }

            #${paymentsLogPrintId},
            #${achLogPrintId},
            #${paymentSourceLogPrintId},
            .MuiBox-root,
            .MuiTableContainer-root,
            .MuiPaper-root {
              height: auto !important;
              max-height: none !important;
              min-height: 0 !important;
              overflow: visible !important;
              box-shadow: none !important;
            }

            .MuiTableContainer-root::-webkit-scrollbar,
            .MuiBox-root::-webkit-scrollbar {
              display: none;
            }
          </style>
        </head>
        <body>
          ${printNode.outerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <Box sx={{ width: "100%", height: "100%", pt: 0 }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <CustomTabButton
            id={`tab-loan-payments-log-${appId}`}
            variant="text"
            onClick={() => handleChange(1)}
            className={activeTab === 1 ? "Mui-selected" : ""}
          >
            Payments Log
          </CustomTabButton>
          <CustomTabButton
            id={`tab-loan-ach-log-${appId}`}
            variant="text"
            onClick={() => handleChange(2)}
            className={activeTab === 2 ? "Mui-selected" : ""}
          >
            ACH Log
          </CustomTabButton>
          <CustomTabButton
            id={`tab-loan-payment-source-log-${appId}`}
            variant="text"
            onClick={() => handleChange(3)}
            className={activeTab === 3 ? "Mui-selected" : ""}
          >
            Payment Source Log
          </CustomTabButton>
        </Box>
        <IconButton
          onClick={handlePrint}
          size="small"
          sx={{ mr: 1, color: "primary.main" }}
          title={
            activeTab === 1
              ? "Print Payments Log"
              : activeTab === 2
              ? "Print ACH Log"
              : "Print Payment Source Log"
          }
          aria-label={
            activeTab === 1
              ? "Print Payments Log"
              : activeTab === 2
              ? "Print ACH Log"
              : "Print Payment Source Log"
          }
        >
          <PrintOutlinedIcon />
        </IconButton>
      </Box>
      <CustomDetailBox
        id={paymentsLogPrintId}
        sx={{ display: activeTab === 1 ? "block" : "none" }}
      >
        <LoanPaymentsMadeTable {...props} />
      </CustomDetailBox>
      <CustomDetailBox
        id={achLogPrintId}
        sx={{ display: activeTab === 2 ? "block" : "none" }}
      >
        <LoanACHLog {...props} />
      </CustomDetailBox>
      <CustomDetailBox
        id={paymentSourceLogPrintId}
        sx={{ display: activeTab === 3 ? "block" : "none" }}
      >
        <LoanPaymentSourceLog {...props} />
      </CustomDetailBox>
    </Box>
  );
};

export default LoanPaymentTab;
